import React from "react";
import { GalleryI } from "@/interfaces/galleries/Galleries";

interface AvatarCardProps {
  gallery: GalleryI;
}

const AvatarCard: React.FC<AvatarCardProps> = ({ gallery }) => {
  return (
    <div className="flex flex-col items-center">
      <div>
        {gallery.avatar && (
          <img
            src={gallery.avatar}
            alt={gallery.name || "Avatar"}
            className="photo"
          />
        )}
      </div>
      <div className="avatar-info text-center">
        <a
          href={`/${gallery.name}`}
          className="font-bold text-lg hover:underline"
        >
          {gallery.name}
        </a>
      </div>
    </div>
  );
};

export default AvatarCard;
